import {
    GET_ROLE,
    SET_ROLE_FIELDS,
    SET_ROLE_SKELETON,
    SET_ROLE_LOADING,
    REMOVE_ROLE_LOADING
} from "../types";

const initialState = {
    loading: false, // Initit loading state
    roleSkeleton: {},
    roleData: {},
    roleFields: {},
    oldValue: ""
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_ROLE_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_ROLE_LOADING:
            return {
                ...state,
                loading: false
            };
        case GET_ROLE:
            return {
                ...state,
                roleData: { ...payload }
            };
        case SET_ROLE_FIELDS:
            return {
                ...state,
                roleFields: { ...payload }
            };
        case SET_ROLE_SKELETON:
            return {
                ...state,
                roleSkeleton: { ...payload }
            };
        default:
            return state;
    }
}